import React, {Component} from 'react'
import Typed from 'typed.js'

class CodeEditor extends Component {
	constructor(props){
		super(props)
		this.state={
			currentCodeIndex:0
		}
		this.setClassById=this.setClassById.bind(this)
		this.showMatrixCode=this.showMatrixCode.bind(this)
		this.createMatrix=this.createMatrix.bind(this)
		this.showNextCode=this.showNextCode.bind(this)
		this.fadeOut=this.fadeOut.bind(this)
		this.fadeIn=this.fadeIn.bind(this)
		this.initTyping=this.initTyping.bind(this)
	}
	componentDidMount() {
		setTimeout(this.initTyping,0)
	}

	componentWillUnmount() {
		clearTimeout(this.timeout)
		this.typed.destroy()
	}
	render() {
		return (
			<div className="code-editor" id="code-editor" aria-label="code editor example">
				<header>
					<div className="code-editor__buttons">
						<span className="red"></span>
						<span className="yellow"></span>
						<span className="green"></span>
					</div>
					<h2 id="code-editor__heading">HTML</h2>
					<div className="code-editor__buttons"></div>
				</header>
				<div className="code-editor__content" id="code-editor__content">
					<div id="code-editor__code"></div>
				</div>
			</div>
		)
	}
	initTyping() {
		if(!document.getElementById('command-line'))return
		const textToPrint = [
			{
				heading: "HTML",
				firstPart: `<span class="bt">&#x3C;section</span> <span class="rt">class=</span><span class="yt">&#x22;customer-info visible&#x22;</span> <span class="rt">id=</span><span class="yt">&#x22;customer-info&#x22;</span><span class="bt">&#x3E;</span>
    <span class="bt">&#x3C;h2</span> <span class="rt">class=</span><span class="yt">&#x22;section-heading&#x22;</span><span class="bt">&#x3E;</span> Customer info<span class="bt">&#x3C;/h2&#x3E;</span>
    <span class="bt">&#x3C;form</span> <span class="rt">class=</span><span class="yt">&#x22;customer-info__form&#x22;</span> <span class="rt">id=</span><span class="yt">&#x22;customer-info__form&#x22;</span><span class="bt">&#x3E;</span>
        <span class="bt">&#x3C;div</span>  <span class="rt">class=</span><span class="yt">&#x22;input-group&#x22;</span><span class="bt">&#x3E;</span>
            <span class="bt">&#x3C;label</span>  <span class="rt">for=</span><span class="yt">&#x22;customer-name&#x22;</span><span class="bt">&#x3E;</span> Name<span class="bt">&#x3C;/label&#x3E;</span>
            <span class="bt">&#x3C;input</span>  <span class="rt">type=</span><span class="yt">&#x22;text&#x22;</span> <span class="rt">id=</span><span class="yt">&#x22;customer-name&#x22;</span> <span class="rt">required</span><span class="bt">&#x3E;</span>
        <span class="bt">&#x3C;/div&#x3E;</span> 
        <span class="bt">&#x3C;div</span>  <span class="rt">class=</span><span class="yt">&#x22;input-group&#x22;</span><span class="bt">&#x3E;</span>
            <span class="bt">&#x3C;label</span>  <span class="rt">for=</span><span class="yt">&#x22;customer-address&#x22;</span><span class="bt">&#x3E;</span> Address<span class="bt">&#x3C;/label&#x3E;</span>
            <span class="bt">&#x3C;input</span>  <span class="rt">type=</span><span class="yt">&#x22;text&#x22;</span> <span class="rt">id=</span><span class="yt">&#x22;customer-address&#x22;</span> <span class="rt">required</span><span class="bt">&#x3E;</span>
        <span class="bt">&#x3C;/div&#x3E;</span> <div id="code-editor__code"></div> `,
				secondPart: `
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="bt">&#x3C;div</span>  <span class="rt">class=</span><span class="yt">&#x22;input-group&#x22;</span><span class="bt">&#x3E;</span>
            <span class="bt">&#x3C;label</span>  <span class="rt">for=</span><span class="yt">&#x22;customer-phone&#x22;</span><span class="bt">&#x3E;</span> Phone<span class="bt">&#x3C;/label&#x3E;</span>
            <span class="bt">&#x3C;input</span>  <span class="rt">type=</span><span class="yt">&#x22;tel&#x22</span>; <span class="rt">pattern=</span><span class="yt">&#x22;.{13,15}&#x22;</span> <span class="rt">maxlength=</span><span class="yt">&#x22;15&#x22;</span> <span class="rt">id=</span><span class="yt">&#x22;customer-phone&#x22;</span>
            <span class="rt">placeholder=</span><span class="yt">&#x22;+1(123)456-7890&#x22;</span><span class="bt">&#x3E;</span>
        <span class="bt">&#x3C;/div&#x3E;</span> 
        <span class="bt">&#x3C;div</span>  <span class="rt">class=</span><span class="yt">&#x22;input-group&#x22;</span><span class="bt">&#x3E;</span>
            <span class="bt">&#x3C;label</span>  <span class="rt">for=</span><span class="yt">&#x22;customer-cell&#x22;</span><span class="bt">&#x3E;</span> Cell<span class="bt">&#x3C;/label&#x3E;</span>
            <span class="bt">&#x3C;input</span>  <span class="rt">type=</span><span class="yt">&#x22;tel&#x22;</span> <span class="rt">pattern=</span><span class="yt">&#x22;.{13,15}&#x22;</span> <span class="rt">maxlength=</span><span class="yt">&#x22;15&#x22;</span> <span class="rt">id=</span><span class="yt">&#x22;customer-cell&#x22;</span>
            <span class="rt">placeholder=</span><span class="yt">&#x22;+1(123)456-7890&#x22;</span>
            <span class="rt">required</span><span class="bt">/&#x3E;</span>
        <span class="bt">&#x3C;/div&#x3E;</span>`
			},
			{
				heading: "Javascript",
				firstPart: `<span class="ot">const</span> express = <span class="yt">require</span>(<span class="bt">'express'</span>);
<span class="ot">const</span> path = <span class="yt">require</span>(<span class="bt">'path'</span>);
<span class="ot">const</span> app = express();
app.<span class="yt">set</span>(<span class="bt">'port'</span>, (process.<span class="vt">env.PORT</span> || 5000));
<span class="ot">const</span> server = app.<span class="yt">listen</span>(app.<span class="yt">get</span>(<span class="bt">'port'</span>));
server.<span class="yt">listen</span>(app.<span class="yt">get</span>(<span class="bt">'port'</span>));
<span class="ot">const</span> io = <span class="yt">require</span>(<span class="bt">'socket.io'</span>)(server);
<div id="code-editor__code"></div>`,
				secondPart: `<span class="ot">const</span> Users = <span class="yt">require</span>(<span class="bt">'./users'</span>);
<span class="ot">const</span> users = <span class="ot">new</span> Users();
<span class="ot">const</span> Rooms = <span class="yt">require</span>(<span class="bt">'./rooms'</span>);
<span class="ot">const</span> rooms = <span class="ot">new</span> Rooms(io);
io.<span class="yt">on</span>(<span class="bt">'connection'</span>, <span class="ot">function</span> (socket) {
	<span class="ot">let</span> params = socket.<span class="vt">handshake.query</span>;
	<span class="ot">let</span> name = params.<span class="vt">name</span>;
	<span class="ot">let</span> avatar = params.<span class="vt">avatar</span>;
	<span class="ot">let</span> roomName = params.<span class="vt">room</span>;
	users.<span class="yt">joinRoom</span>(socket, name, roomName, avatar);
	socket.<span class="yt">emit</span>(<span class="bt">'updateRoomList'</span>, rooms.<span class="yt">getPublicRoomList</span>());`
			},
			{
				heading: "PHP",
				firstPart: `<span class="ot">class</span> DB
{
    ....
    <span class="ot">public static function</span> <span class="yt">getInstance</span>()
    {
        <span class="ot">if</span>(<span class="ot">self::</span>$instance===<span class="ot">null</span>){
            <span class="ot">self::</span><span class="vt">$instance</span>=<span class="ot">new self</span>;
        }
        <span class="ot">return self</span>::<span class="vt">$instance</span>;
        <div id="code-editor__code"></div>
    }`,
				secondPart: `&nbsp;&nbsp;&nbsp;&nbsp;<span class="ot">private function</span> <span class="yt">__construct</span>()
    {
        <span class="vt">$this</span>-><span class="vt">host</span>=Config::<span class="yt">get</span>(<span class="bt">'db.host'</span>);
        <span class="vt">$this</span>-><span class="vt">user</span>=Config::<span class="yt">get</span>(<span class="bt">'db.user'</span>);
        <span class="vt">$this</span>-><span class="vt">password</span>=Config::<span class="yt">get</span>(<span class="bt">'db.password'</span>);
        <span class="vt">$this</span>-><span class="vt">db_name</span>=Config::<span class="yt">get</span>(<span class="bt">'db.db_name'</span>);
        <span class="ot">try</span> {
            <span class="vt">$this</span>-><span class="vt">connection</span> = <span class="ot">new</span> \\PDO(<span class="bt">"mysql:host=<span class="vt">$this</span></span>-><span class="bt"><span class="vt">host</span>;dbname=<span class="vt">$this</span>-><span class="vt">db_name</span>"</span>, <span class="vt">$this</span>-><span class="vt">user</span>, <span class="vt">$this</span>-><span class="vt">password</span>);
            <span class="vt">$this</span>-><span class="vt">connection</span>-><span class="yt">setAttribute</span>( \\PDO::ATTR_ERRMODE, &#x3C;PDO::ERRMODE_EXCEPTION );

        }<span class="ot">catch</span>(\\PDOException <span class="vt">$e</span>) {
            <span class="ot">echo</span> <span class="vt">$e</span>-><span class="yt">getMessage</span>();
        }
        <span class="vt">$this</span>-><span class="vt">connection</span>-><span class="yt">query</span>(<span class="bt">'SET NAMES UTF8'</span>);`
			},
			{
				heading: "C#",
				firstPart: `<span class="bt">using</span> System;
<span class="bt">using</span> System.Collections.Generic;
<span class="bt">using</span> System.Linq;
<span class="bt">using</span> System.Web;
<span class="bt">using</span> System.Web.UI;
<span class="bt">using</span> System.Web.UI.WebControls;
<span class="bt">using</span> Oracle.ManagedDataAccess.Client;

<span class="bt">namespace</span> WebApplication1
        <div id="code-editor__code"></div>`,
				secondPart: `{

    <span class="bt">public partial class</span> <span class="vt">VendorContacts</span> : System.Web.UI.<span class="vt">Page</span>
    {
    	<span class="vt">OracleConnection</span> conn;
    	
        <span class="bt">protected void</span> Page_Load(<span class="bt">object</span> sender, <span class="vt">EventArgs</span> e)
        {
            conn = <span class="bt">new</span> <span class="vt">OracleConnection</span>();
            <span class="bt">string</span> host = <span class="ot">"example.com"</span>;`
			},
			{
				heading: "SQL",
				firstPart: `<span class="bt">SELECT
    gla</span>.account_description,
    <span class="bt">COUNT</span>(<span class="bt">ili</span>.invoice_id) <span class="bt">AS</span> "count",
    <span class="bt">SUM</span>(<span class="bt">ili</span>.line_item_amt) <span class="bt">AS</span> "sum"
<span class="bt">FROM</span>
    general_ledger_accounts <span class="bt">gla</span>
    <span class="bt">JOIN</span> invoice_line_items <span class="bt">ili ON gla</span>.account_number = <span class="bt">ili</span>.account_number
<div id="code-editor__code"></div>`,
				secondPart: `&nbsp;&nbsp;&nbsp;&nbsp;<span class="bt">JOIN</span> invoices <span class="bt">i ON ili</span>.invoice_id = <span class="bt">i</span>.invoice_id
<span class="bt">WHERE</span>
        <span class="bt">i</span>.invoice_date >= '1-JUL-2008'
    <span class="bt">AND</span>
        <span class="bt">i</span>.invoice_date <= '30-SEP-2008'
<span class="bt">GROUP BY</span>
    <span class="bt">gla</span>.account_description
<span class="bt">HAVING</span>
    <span class="bt">COUNT</span>(<span class="bt">ili</span>.invoice_id) > 1
<span class="bt">ORDER BY</span> "sum" <span class="bt">DESC</span>;`
			},
		]
		this.typed=new Typed('#command-line', {
			strings: [
				'HTML5/CSS3: Bootstrap',
				'HTML5/CSS3: SASS/LESS',
				'HTML5/CSS3: BEM',
				'HTML5/CSS3: Accessibility',
				'Javascript&#58; ES6',
				'Javascript&#58; React',
				'Javascript&#58; NodeJS',
				'Javascript&#58; Express',
				'Javascript&#58; HTML5 Canvas',
				'PHP: OOP',
				'PHP: MVC',
				'PHP: PDO',
				'PHP: Composer',
				'PHP: Wordpress',
				'C#: ASP.NET',
				'C#: OOP',
				'C#: MVC',
				'MySQL',
				'MSSQL',
				'Oracle',
				'MongoDB',
				'making awesome apps'
			],
			startDelay: 500,
			typeSpeed: 50,
			backSpeed: 0,
			smartBackspace: true, // this is a default
			loop: false,
			onStringTyped: (arrayPos, self) => {
				const idArray = [
					'item--bootstrap', 'item--sass', 'item--bem', 'item--accessibility',
					'item--es6', 'item--react', 'item--node', 'item--express', 'item--canvas',
					'item--php', 'item--phpmvc', 'item--pdo', 'item--composer', 'item--wordpress',
					'item--asp', 'item--coop', 'item--cmvc',
					'item--mysql', 'item--mssql', 'item--oracle', 'item--mongo'
				]
				const currentStringId = idArray[arrayPos]
				this.setClassById(currentStringId, 'typed')
				if (currentStringId === 'item--accessibility' ||
					currentStringId === 'item--canvas' ||
					currentStringId === 'item--wordpress' ||
					currentStringId === 'item--cmvc') {
					this.showNextCode(textToPrint[this.state.currentCodeIndex])
				}
				if (currentStringId === 'item--mongo') {
					this.showMatrixCode()
				}
			},
		});
		this.showNextCode(textToPrint[this.state.currentCodeIndex])
	}

	setClassById(id, className) {
		const elem = document.getElementById(id);
		if (!elem)return
		elem.classList.add(className)
	}

	showMatrixCode() {
		if (window.innerWidth < 1230)return
		this.fadeOut(document.getElementById('code-editor__content'))
		this.timeout=setTimeout(() => {
			const codeContent =document.getElementById('code-editor__content')
			codeContent.innerHTML = "<canvas class='matrix-code' id='matrix-code'></canvas>";
			codeContent.style.padding=0
			document.getElementById('code-editor__heading').innerHTML = 'Web development';
			this.createMatrix()
			this.fadeIn(document.getElementById('code-editor__content'))
		}, 1000)
	}

	createMatrix() {
		const matrix = document.getElementById("matrix-code");
		const ctx = matrix.getContext("2d");
		let alphabet = "abcdefghigklmnopqrstuvwxyz1234567890";
		alphabet = alphabet.split("");
		const font_size = 5;
		const columns = matrix.width / font_size; //number of columns for the rain
		const drops = [];
		for (let x = 0; x < columns; x++)
			drops[x] = 1;
		const draw = () => {
			ctx.fillStyle = "rgba(7, 15, 39, 0.05)";
			ctx.fillRect(0, 0, matrix.width, matrix.height);
			ctx.fillStyle = "#4c8e9e";
			ctx.font = font_size + "px arial";
			for (let i = 0; i < drops.length; i++) {
				let text = alphabet[Math.floor(Math.random() * alphabet.length)];
				//x = i*font_size, y = value of drops[i]*font_size
				ctx.fillText(text, i * font_size, drops[i] * font_size);
				if (drops[i] * font_size > matrix.height && Math.random() > 0.975)
					drops[i] = 0;
				drops[i]++;
			}
		}

		setInterval(draw, 33);
	}

	showNextCode(code) {
		if (window.innerWidth < 1240)return
		this.setState({currentCodeIndex:this.state.currentCodeIndex+1})
		this.fadeOut(document.getElementById('code-editor__content'))
		this.timeout = setTimeout(() => {
			document.getElementById('code-editor__content').innerHTML = code.firstPart;
			document.getElementById('code-editor__heading').innerHTML = code.heading;
			this.fadeIn(document.getElementById('code-editor__content'))
			new Typed('#code-editor__code', {
				strings: [
					"", code.secondPart
				],
				startDelay: 0,
				typeSpeed: 0,
				backSpeed: 0,
				loop: false,
			})
		}, 1000)
	}

	fadeOut(el) {
		el.classList.remove('fadeIn')
		el.classList.add('fadeOut')
	}

	fadeIn(el) {
		el.classList.remove('fadeOut')
		el.classList.add('fadeIn')
	}
}

export default CodeEditor



// WEBPACK FOOTER //
// ./src/components/CodeEditor.js